import { lazy } from "react";

export const CreateDictionaryValue = lazy(
  () => import("./dictionary-create-value"),
);
export { DICTIONARY_VALUE_CREATE_PATH } from "./dictionary-create-value-path";
export { ToDictionaryCreateValue } from "./to-dictionary-create-value";
